export const getYear = () => {
  const year = new Date().getFullYear();
  return year;
};
